import _ from "lodash";

export default function isLastItemInList<T>(
  data: Array<T>,
  dataItem: T,
  idField: string
): boolean {
  if (data.length === 0) {
    return false;
  }

  return (
    data.findIndex((x) => _.get(x, idField) === _.get(dataItem, idField)) ===
    data.length - 1
  );
}
